export const soccerTestSet: string[] = [
  "EPL 팀",
  "라리가 팀",
  "분데스리가 팀",
  "K리그 팀",
  "한국인 축구선수",
  "역대 발롱도르 수상자",
  "역대 유럽 챔피언스리그 우승팀",
  "해외 축구선수 이름",
  "EPL에서 뛰어본 한국인 선수",
  "역대 월드컵 개최지",
  "역대 월드컵 우승 국가",
]